
import Api from './Api'
export default {
  GetConvertFormula(payload) {
    return Api().post(`/api/admin/getconvertformula`, payload);
  }

}



// WEBPACK FOOTER //
// ./src/services/UnitConverterService.js